import { a as t } from "../../../chunk-OA3DH5LS-40f95340.js";
const e = t("Table").parts(
  "actions",
  "avatar",
  "avatarBadge",
  "avatarContent",
  "avatarEmpty",
  "avatarSubTitle",
  "avatarTitle",
  "container",
  "shadow",
  "shadowContent",
  "shortcuts",
  "skeletonCell",
  "skeletonFullTd",
  "skeletonTbodyRow",
  "skeletonTd",
  "table",
  "tbodyData",
  "tbodyRow",
  "tcellAlignCenter",
  "tcellAlignLeft",
  "tcellAlignRight",
  "tcellBackground",
  "tcellBorderLeft",
  "tcellBorderRight",
  "theadHeader",
  "theadRow"
);
export {
  e as TableAnatomy
};
//# sourceMappingURL=Table.anatomy.es.js.map
